import React from 'react';

// Íconos del panel lateral: Phosphor Light en reposo y la variante Fill en el
// ítem activo, como las barras de iOS. Se pasan los dos componentes por
// separado (y no un nombre) para que el bundle solo incluya los que se usan.
export const navIcon = (Light, Fill) => ({
    icon: <Light className="text-xl" />,
    activeIcon: <Fill className="text-xl" />,
});

// Ícono con una insignia chica abajo a la derecha (p. ej. caja + lupa para
// "Packs por verificar"), para las opciones que Phosphor no trae combinadas.
const Badged = ({ Base, Badge }) => (
    <span className="relative block w-[1em] h-[1em] leading-none text-xl">
        <Base className="block" />
        <Badge className="absolute -right-1 -bottom-1 text-[11px] rounded-full bg-white dark:bg-gray-900" />
    </span>
);

export const navIconBadged = (BaseLight, BaseFill, Badge) => ({
    icon: <Badged Base={BaseLight} Badge={Badge} />,
    activeIcon: <Badged Base={BaseFill} Badge={Badge} />,
});
